import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Modal, notification } from 'antd';
import { getEntities as getKrCheckIn, reset } from 'app/entities/checkIn/checkIn.reducer';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import ReportQualitativeResult from './reportQualitativeResult';
import ReportQuantitativeResult from './reportQuantitativeResult';

type IReportQualitativeResult = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  krSelected?: string;
};

export const ReportKr = ({ isOpen, onClose, krSelected }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();

  const checkInList = useAppSelector(state => state.checkIn.entities);
  const filters = useAppSelector(state => state.filters.orgCheckIn);

  const [krReportInfo, setKrReportInfo] = useState<any>(krSelected);

  const handleClose = () => {
    dispatch(reset());
    onClose();
  };

  useEffect(() => {
    if (isOpen && filters?.planPeriodId && !krSelected) innitData();
  }, [isOpen, filters, krSelected]);

  useEffect(() => {
    if (checkInList) {
      if (checkInList.length <= 0) {
        notification.warning({ message: 'Tất cả các KR đã được check in', placement: 'topLeft' });
        handleClose();
        return;
      }
      else if (!krSelected)
        setKrReportInfo(checkInList[0]);
    }
  }, [checkInList]);

  const innitData = () => {
    dispatch(getKrCheckIn({ planPeriodId: filters?.planPeriodId, checkinType: 1, partyId: filters?.accountableId, reportScheduleId: 'a276551d-37ee-4434-8b88-1f495d3196a7' }));
  };

  const handleNext = () => {
    innitData()
  };

  return krReportInfo ? (
    <Modal
      width={krReportInfo?.krType === KrTypes.Qualitative ? '100vw' : 1300} // Full width
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      {krReportInfo?.krType === KrTypes.Qualitative ? (
        <ReportQualitativeResult krCheckIn={krReportInfo} hideNextKr={krSelected !== null ? true : false} handleNextData={handleNext} handleClose={handleClose} />
      ) : (
        <ReportQuantitativeResult krCheckIn={krReportInfo} hideNextKr={krSelected !== null ? true : false} handleNextData={handleNext} handleClose={handleClose} />
      )}
    </Modal>
  ) : undefined;
};

export default ReportKr;
